module.exports = __webpack_public_path__ + "img/Z82_11.1a736130.jpg";